export enum EResourceCrud {
  BANS = "bans",
  USERS = "users",
  ORDERS = "orders",
  ARTICLES = "articles",
  CATEGORIES = "categories",
  TICKETS = "tickets",
  JOBS = "jobs",
  WORKS = "works",
  OPERATIONS = "operations",
  FEEDBACK = "feedback",
}
export interface PaginationParams {
  current?: number;
  pageSize?: number;
}

export interface FilterParams {
  field: string;
  operator:
    | "contains"
    | "startswith"
    | "endswith"
    | "eq"
    | "ne"
    | "gt"
    | "gte"
    | "lt"
    | "lte";
  value: any;
}

export interface SorterParams {
  field: string;
  order: "asc" | "desc";
}

export interface GetListRequest {
  pagination?: PaginationParams;
  filters?: FilterParams[];
  sorters?: SorterParams[];
}
